var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 21,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2020"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1956",
    d: "M20.08,14.57c-.4,0-.72.32-.72.72v2.88c0,.66-.54,1.2-1.2,1.2H2.83c-.66,0-1.2-.54-1.2-1.2h0v-2.88c0-.4-.32-.72-.72-.72-.4,0-.72.32-.72.72h0v2.88c0,1.46,1.18,2.64,2.64,2.64h15.34c1.46,0,2.64-1.18,2.64-2.64v-2.88c0-.4-.32-.72-.72-.72h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1957",
    d: "M10.5.2c-.4,0-.72.32-.72.72v11.88l-4.57-3.81c-.32-.23-.77-.16-1,.17-.21.29-.17.69.08.93l5.75,4.79s.07.05.11.06c.03.02.06.04.09.05.17.07.35.07.52,0,.03-.01.06-.03.09-.05.04-.02.08-.04.11-.06l5.75-4.78c.28-.28.29-.73.01-1.02-.25-.26-.65-.29-.93-.08l-4.57,3.8V.92c0-.4-.32-.72-.72-.72",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/icon-download-white.a28fccd9175b7ff9c95b1d69ea515bc7.svg";
export { ForwardRef as ReactComponent };